import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core'
import { RouterLink, RouterOutlet } from '@angular/router'
import { AppConfigService } from '@mos/client/shared/app-config'
import { markApplicationAsReady } from '@mos/client/shared/utils'
import { LandingService } from '@mos/client/web/landing/data-access/landing.service'
import { SocialLinksComponent } from '../../components/social-links/social-links.component'
import { LandingAuthenticationModal } from '../../modals/landing-authentication/landing-authentication.modal'
import { PreRegistrationCompleteModal } from '../../modals/pre-registration-complete/pre-registration-complete.modal'
import { LandingBurgerMenuComponent } from '../landing-burger-menu/landing-burger-menu.component'

@Component({
	imports: [
		RouterLink,
		RouterOutlet,
		LandingBurgerMenuComponent,
		SocialLinksComponent,
		LandingAuthenticationModal,
		PreRegistrationCompleteModal,
	],
	providers: [],
	templateUrl: './landing.layout.html',
	styleUrls: ['./landing.layout.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LandingLayout implements OnInit {
	readonly landingService = inject(LandingService)
	readonly configService = inject(AppConfigService)

	ngOnInit(): void {
		markApplicationAsReady()
	}
}
